import { type Event, EventListener, View, type ViewData } from "silver";
import { TableHeaderClone } from "core/Controls/TableHeaderClone";

const controlHtml = `<div class="fixedHeaderTable">
						<div data-myon-name="fixedHeaderContainer" class="fixedHeaderTable_cloneContainer"></div>
						<div data-myon-name="tableContainer" class="fixedHeaderTable_tableContainer"></div>
					</div>`;

interface ScrollEvent extends Event {
	scrollTop: number;
	scrollLeft: number;
}

interface FixedHeaderTableView extends View<ViewData> {
	fixedHeaderContainer: HTMLDivElement;
	fixedHeader: HTMLDivElement;
	tableContainer: HTMLDivElement;
}

export class FixedHeaderTable {

	public readonly onScroll = EventListener.create<ScrollEvent>("scroll");

	private view: FixedHeaderTableView;
	private clonedHeader: TableHeaderClone;
	private initialized: boolean = false;
	public readonly element: HTMLElement;

	constructor(
		private table: HTMLTableElement,
		private height: number
	) {
		this.clonedHeader = new TableHeaderClone(table);
		this.view = new View<ViewData>(controlHtml, { }, { }) as FixedHeaderTableView;
		this.element = this.view.element;
		this.view.fixedHeaderContainer.appendChild(this.clonedHeader.element);
		this.clonedHeader.element.classList.add("fixedHeaderTable_cloneTable");
		this.initialize();
		this.setHeight(height);
	}

	public resize(): void {
		this.clonedHeader.resize();

		const headerHeight = this.clonedHeader.headerHeight as number;
		if (headerHeight > 0) {
			this.view.fixedHeaderContainer.style.height = `${headerHeight}px`;
			this.table.style.marginTop = `${-1 * headerHeight}px`;
			this.initialized = true;
			this.view.element.classList.add("-initialized");
		}

		this.view.tableContainer.style.maxHeight = `${this.height - headerHeight}px`;
	}

	public setHeight(height: number): void {
		this.height = height;
		const headerHeight = this.clonedHeader.headerHeight;
		if (headerHeight) {
			this.view.tableContainer.style.maxHeight = `${this.height - headerHeight}px`;
		}
	}

	public getHeight(): number {
		return this.height;
	}

	private initialize() {
		if (this.table.parentNode) {
			this.table.parentNode.insertBefore(this.view.element, this.table);
		}
		this.view.tableContainer.appendChild(this.table);
		window.addEventListener("resize", () => this.resize());
		let isScrolled = false;
		window.addEventListener("scroll", () => {
			if (this.view.tableContainer.scrollLeft !== 0 || isScrolled) {
				this.view.fixedHeader.style.marginLeft = String(-this.view.tableContainer.scrollLeft) + "px";
				isScrolled = (this.view.tableContainer.scrollLeft !== 0);
			}
			this.onScroll.trigger({ scrollTop: this.view.tableContainer.scrollTop, scrollLeft: this.view.tableContainer.scrollLeft });
		});
		this.view.tableContainer.addEventListener("scroll", () => {
			if (!this.initialized) {
				this.resize();
			}
			this.onScroll.trigger({ scrollTop: this.view.tableContainer.scrollTop, scrollLeft: this.view.tableContainer.scrollLeft });
		});

		setTimeout(() => this.resize(), 10);
	}
}
